// extracted by mini-css-extract-plugin
export var tosLink = "_52-0";